<template>
  <div
    v-if="listenForClick"
    :class="classnames"
    @click="handleClick"
    v-external-click="close"
  >
    <slot />
  </div>

  <div
    v-else-if="listenForHover"
    :class="classnames"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <slot />
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'
  import { helpers } from '@/mixins/helpers.js'

  const namespace = 'popup-hitzone'

  export default {
    name: 'PopupHitzone',
    mixins: [ bem, helpers ],
    props: {
      close: {
        type: Function
      },
      listenFor: {
        type: String
      }
    },
    data: function () {
      return {
        mouseMovingInHitzone: false
      }
    },
    computed: {
      listenForClick: function () {
        return this.listenFor === 'click'
      },
      listenForHover: function () {
        return this.listenFor === 'hover'
      }
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      handleClick: function () {
        this.$emit('click')
      },
      handleMouseEnter: function () {
        this.$emit('mousein')
      },
      handleMouseLeave: function () {
        this.$emit('mouseout')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Popup/PopupHitzone.vue